import { render, staticRenderFns } from "./ms-lead-update.vue?vue&type=template&id=33ddf6b2&scoped=true"
import script from "./ms-lead-update.vue?vue&type=script&lang=js"
export * from "./ms-lead-update.vue?vue&type=script&lang=js"
import style1 from "./ms-lead-update.vue?vue&type=style&index=1&id=33ddf6b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ddf6b2",
  null
  
)

export default component.exports